// ─── Theme color presets (switchable at runtime) ─────────────────────────────
// Each preset mirrors the MUI primary color shape used across the app.
// `mainRgb` is the "r, g, b" string for CSS rgba() use (App.css variables).

export const DEFAULT_THEME_COLOR = 'blue';

const BLUE = {
  lighter: '#DBEAFE',
  light: '#60A5FA',
  main: '#2563EB',
  dark: '#1D4ED8',
  darker: '#1E3A8A',
  contrastText: '#FFFFFF',
  mainRgb: '37, 99, 235',
};

const RED = {
  lighter: '#FEE2E2',
  light: '#FCA5A5',
  main: '#EF4444',
  dark: '#B91C1C',
  darker: '#7F1D1D',
  contrastText: '#FFFFFF',
  mainRgb: '239, 68, 68',
};

const GREEN = {
  lighter: '#DCFCE7',
  light: '#86EFAC',
  main: '#16A34A',
  dark: '#15803D',
  darker: '#14532D',
  contrastText: '#FFFFFF',
  mainRgb: '22, 163, 74',
};

export const THEME_PRESETS = {
  blue: BLUE,
  red: RED,
  green: GREEN,
};

// Order + labels for the picker UI.
export const THEME_OPTIONS = [
  { value: 'blue', label: 'Blue', color: BLUE.main },
  { value: 'red', label: 'Red', color: RED.main },
  { value: 'green', label: 'Green', color: GREEN.main },
];
